import { TIME_PERIOD } from "constants/timePeriod";

function timePeriodCodeToName(code) {
  return TIME_PERIOD[code];
}

export { timePeriodCodeToName };
